// B2BMaskedPassword.js
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import useB2BTranslation from './hooks/useB2BTranslation';

const B2BMaskedPassword = ({ label, value, className, readOnly, onChange }) => {
    const { t } = useB2BTranslation('b2b-common');
    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    return (
        <TextField
            label={label}
            variant="standard"
            color="primary"
            type={showPassword ? 'text' : 'password'}
            className={className}
            value={value}
            onChange={onChange}
            InputProps={{
                ...(!readOnly && {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={handleTogglePasswordVisibility} aria-label={t('Toggle password visibility')}>
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    ),
                }),
            }}
        />
    );
};

B2BMaskedPassword.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    className: PropTypes.string,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func,
};

export default B2BMaskedPassword;